<script setup>
import { computed, defineEmits, defineProps } from 'vue';

const props = defineProps({ visible: Boolean });
const emit = defineEmits(['update:visible', 'confirm']);

const visible = computed({
  get() {
    return props.visible;
  },
  set(val) {
    emit('update:visible', val);
  },
});
</script>

<template>
  <van-dialog
    v-model="visible"
    :title="$t('dialog.crossBorder.header')"
    show-cancel-button
    :confirm-button-text="$t('dialog.agreeButton')"
    :cancel-button-text="$t('dialog.disagreeButton')"
    @confirm="emit('confirm')"
  >
    <div class="content text-sm">
      {{ $t('dialog.crossBorder.text') }}
    </div>
  </van-dialog>
</template>

<style scoped lang="less">
.content {
  color: #595959;
}
</style>
